import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { DirektvermarktungContractResponse } from "../Direktvermarktung.types";

export const direktvermarktungContractQueries = {
  all: () =>
    queryOptions<DirektvermarktungContractResponse>({
      queryKey: ["direktvermarktungContract"]
    }),
  detail: (contractId?: string) =>
    queryOptions<DirektvermarktungContractResponse>({
      queryKey: ["direktvermarktungContract", { contractId }],
      queryFn: contractId
        ? () => fetchDirektvermarktungContract(contractId)
        : skipToken
    })
};

export function useDirektvermarktungContract(
  contractId?: string,
  options?: Partial<UseQueryOptions<DirektvermarktungContractResponse>>
) {
  return useQuery({
    ...direktvermarktungContractQueries.detail(contractId),
    ...options
  });
}

export async function fetchDirektvermarktungContract(
  contractId: string
): Promise<DirektvermarktungContractResponse> {
  const response =
    await apiWithoutCamelization.get<DirektvermarktungContractResponse>(
      urls.apiWithoutCamelization.direktvermarktungContract(contractId)
    );
  return response.data;
}
